export function getStorageItemWarehouseId (item) {
  return item?._embedded?.warehouse?.id || item?.warehouse || null
}

export function withStorageItemWarehouseFilter (warehouseId, query = {}) {
  if (!warehouseId) {
    return query
  }

  const filter = Array.isArray(query.filter) ? query.filter : []
  const hasWarehouseFilter = filter.some(item => item.field === 'warehouse')

  if (hasWarehouseFilter) {
    return query
  }

  return {
    ...query,
    filter: [
      ...filter,
      { type: 'eq', field: 'warehouse', value: warehouseId }
    ]
  }
}
